<template>
    <div class="app-header-login flex flex-row md:gap-x-12 items-center">
        <button-menu buttonRoute="/login" buttonText="Login"></button-menu>
    </div>
</template>

<script>
export default {
    name: 'AppHeaderLogin',
};
</script>
